import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { EndpointService } from "@app/core";
import { ToastrService } from "ngx-toastr";
import { reject } from "lodash";
import { error } from "console";
import { resolve } from "url";

export interface Usuarios {
  nombre: string;
  apellido: string;
  id: number;
  identificacion: number;
}

export interface Reason {
  id: number;
  nombre: string;
}

export interface HistoryUser {
  id: number;
  motivo: Reason,
  fecha_inicial: Date,
  fecha_final?: Date,
}

@Injectable()
export class InactivateUserDataService {
  constructor(private http: HttpClient, private api: EndpointService, private toastr: ToastrService) {}

  /**
   * Obtener todos los usuarios
   */
  getAllUsersSystem(): Observable<Usuarios[]>{
    return new Observable(obs => {
      this.http.get<Usuarios[]>(this.api.get('allUserSystem')).subscribe(
        users => {
          obs.next(users);
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta del historial de inactivaciones por usuario
   */
  getHistoryUsers(id: number): Promise<HistoryUser[]> {
    return new Promise((resolve, reject) => {
      this.http.get<HistoryUser[]>(this.api.get('historyUsersInactivation', [id])).subscribe(
        history => {
          resolve(history);
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

  /**
   * Registrar inactivación de usuario
   * @memberof InactivateUserDataService
   * 
   */
  addUserInactivation(data: any): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('historyUsersInactivation'), data).subscribe(
        resp => {
          this.toastr.success("Operación exitosa", "Inactivación agregada correctamente");
          resolve(true);
        },
        err => {
          if(err.status == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.status == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

  /**
   * Eliminar inactivación de usuario
   */
  deleteUserInactivation(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('historyUsersInactivation', [id])).subscribe(
        resp => {
          this.toastr.success("Operación exitosa", "Inactivación eliminada correctamente");
          resolve(true);
        },
        (err) => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

  getAllReason(): Observable<Reason[]>{
    return new Observable(obs => {
      this.http.get<Reason[]>(this.api.get('userInactivationReason')).subscribe(
        reasons => {
          obs.next(reasons);
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * @param reason 
   * @returns
   * @memberof InactivateUserDataService
   */
  addReasonInactivation(reason: any): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('userInactivationReason'), reason).subscribe(
        resp => {
          this.toastr.success("Operación exitosa", "Motivo agregado correctamente");
          resolve(true);
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          }  else if (err.status == 500) {
            this.toastr.warning("Operación fallida", err.error.message);
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

  updateReasonInactivation(id: number, detail: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('userInactivationReason', [id]), detail).subscribe(
        resp => {
          this.toastr.success("Operación exitosa", "Motivo actualizado correctamente");
        },
        err => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

  deleteReasonInactivation(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('userInactivationReason', [id])).subscribe(
        resp => {
          this.toastr.success("Operación exitosa", "Motivo eliminado correctamente");
          resolve(true);
        },
        (err) => {
          if(err.code == 400) {
            this.toastr.warning("Operación fallida", err.error);
          } else if (err.code == 403) {
            this.toastr.warning("Operación fallida", "Permisos insuficientes");
          } else {
            this.toastr.warning("Operación fallida", "No se pudo realizar la acción");
          }
          reject(err);
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/inactivate-users/shared/inactive-users-data.services.ts